import { api } from "@/lib/api";
import type {
  ComponentHealth,
  EnvCard,
  OverviewKpis,
  OverviewStatus,
  Sla,
  SystemEvent,
} from "@/lib/types";
import { useQuery } from "@tanstack/react-query";

const POLL_30S = { refetchInterval: 30_000 };
const POLL_60S = { refetchInterval: 60_000 };

export function useOverviewStatus() {
  return useQuery({
    queryKey: ["overview", "status"],
    queryFn: () => api<OverviewStatus>("/api/ops/v1/overview/status"),
    ...POLL_30S,
  });
}

export function useOverviewKpis() {
  return useQuery({
    queryKey: ["overview", "kpis"],
    queryFn: () => api<OverviewKpis>("/api/ops/v1/overview/kpis"),
    ...POLL_30S,
  });
}

export function useOverviewEnvironments() {
  return useQuery({
    queryKey: ["overview", "environments"],
    queryFn: () => api<EnvCard[]>("/api/ops/v1/overview/environments"),
    ...POLL_30S,
  });
}

export function useOverviewSla() {
  return useQuery({
    queryKey: ["overview", "sla"],
    queryFn: () => api<Sla>("/api/ops/v1/overview/sla"),
    ...POLL_60S,
  });
}

export function useOverviewEvents() {
  return useQuery({
    queryKey: ["overview", "events"],
    queryFn: () => api<SystemEvent[]>("/api/ops/v1/overview/events"),
    ...POLL_30S,
  });
}

export function useOverviewComponents() {
  return useQuery({
    queryKey: ["overview", "components"],
    queryFn: () => api<ComponentHealth[]>("/api/ops/v1/overview/components"),
    ...POLL_30S,
  });
}
